import { render } from "./BulkTracking.vue?vue&type=template&id=75c410f8&scoped=true"
import script from "./BulkTracking.vue?vue&type=script&lang=ts"
export * from "./BulkTracking.vue?vue&type=script&lang=ts"

import "./BulkTracking.vue?vue&type=style&index=0&id=75c410f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75c410f8"

export default script